import { render } from "./InventoryItemCreateDialog.vue?vue&type=template&id=09e4f298"
import script from "./InventoryItemCreateDialog.vue?vue&type=script&lang=js"
export * from "./InventoryItemCreateDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__